import React from 'react';

import ExternalLink from 'components/generic/ExternalLink.component';
import S from 'constants/string.const';
import { useTranslation } from 'providers/GILT.provider';

import CN from './PromptContent.module.scss';

const LINK = 'https://help.getslick.com/en/articles/4664387-take-upfront-deposits-via-slick-pay-to-stop-no-shows';

const PromptContent = () => {
  const { t } = useTranslation();

  return (
    <div data-bem="PromptContent" className={CN.container}>
      <h5 className={CN.title}>{t('scheduler.createDeposit.promptContent.title')}</h5>

      <div className={CN.textLogo}>
        <strong>{t('scheduler.createDeposit.promptContent.companyName')}</strong> {t('scheduler.createDeposit.promptContent.subtitle')}
      </div>

      <div className={CN.texEmoji}>
        <span className={CN.emoji} role="img" aria-labelledby="Star">
          {S.star}
        </span>
        {S.space}
        {t('scheduler.createDeposit.promptContent.bullet1')}
      </div>
      <div className={CN.texEmoji}>
        <span className={CN.emoji} role="img" aria-labelledby="Star">
          {S.star}
        </span>
        {S.space}
        {t('scheduler.createDeposit.promptContent.bullet2')}
      </div>
      <div className={CN.texEmoji}>
        <span className={CN.emoji} role="img" aria-labelledby="Star">
          {S.star}
        </span>
        {S.space}
        {t('scheduler.createDeposit.promptContent.bullet3')}
      </div>

      <span className={CN.text}>{t('scheduler.createDeposit.promptContent.sendLinkGuide')}</span>
      <ExternalLink link={LINK} variant="invert">
        {t('scheduler.createDeposit.promptContent.learnMoreButton')}
      </ExternalLink>
    </div>
  );
};

export default PromptContent;
